import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactPaginate from 'react-paginate'
import styles from './Pagination.scss'

class Pagination extends Component {
  constructor(props) {
    super(props)

    this.state = {

    }
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  handlePageClick = (event) => {
    const { handleChange } = this.props
    if (handleChange) {
      handleChange(event.selected)
    }
  }

  render() {
    return (
      <div className={styles.paginationWrapper}>
        <ReactPaginate
          activeClassName={styles.active}
          containerClassName={styles.pagination}
          initialPage={0}
          marginPagesDisplayed={1}
          nextLabel=">"
          onPageChange={this.handlePageClick}
          pageClassName={styles.page}
          // activeLinkClassName={styles.active}
          pageCount={this.props.pageCount}
          pageRangeDisplayed={3}
          previousLabel="<"
        />
      </div>
    )
  }
}

Pagination.propTypes = {
  handleChange: PropTypes.func,
  pageCount: PropTypes.number,
}

Pagination.defaultProps = {
  handleChange: null,
  pageCount: 1,
}

export default Pagination



// WEBPACK FOOTER //
// ./src/components/Pagination/Pagination.js